import axios from '@/libs/api.request';
import axiosRequest from 'axios';
import search from '@/libs/search';

import { getAreaList } from '@/api/modules/system-management/area-management';
import { webGetAllRegion } from '@/api/modules/system-management/region-management';

export const getBinFenCustomerUserList = data => {
    return axios.request({
        url: 'api/accountManagement/binFenCustomerUserManagement/getBinFenCustomerUserList',
        data: data,
        method: 'post'
    });
};

export const getBinFenCustomerUserDetail = userBinFenCustomerLoginUuid => {
    return axios.request({
        url: 'api/accountManagement/binFenCustomerUserManagement/getBinFenCustomerUserDetail',
        data: { userBinFenCustomerLoginUuid },
        method: 'post'
    });
};

export const pageInit4UserBinFenCustomerEdit = () => {
    const areaSearch = search.getSearchParams({ closeAllConditions: true });

    return axiosRequest.all([
        getAreaList(areaSearch),
        webGetAllRegion()
    ]).then(axiosRequest.spread(function (area, region) {
        if (area.code === 0) {
            return {
                code: 0,
                message: '',
                data: {
                    area: area.data,
                    region: region.data
                }
            };
        }
    }));
};

export const pageInit4UserBinFenCustomerEditNew = () => {
    const areaSearch = search.getSearchParams({ closeAllConditions: true });

    return axiosRequest.all([
        getAreaList(areaSearch),
        getAllRegion()
    ]).then(axiosRequest.spread(function (area, region) {
        if (area.code === 0) {
            return {
                code: 0,
                message: '',
                data: {
                    area: area.data,
                    region: region.data
                }
            };
        }
    }));
};

export const binFenCustomerUserSave = data => {
    return axios.request({
        url: 'api/accountManagement/binFenCustomerUserManagement/binFenCustomerUserSave',
        data: data,
        method: 'post'
    });
};

export const getAllRegion = data => {
    return axios.request({
        url: 'api/systemManagement/regionManagement/getAllRegion',
        data: data,
        method: 'post'
    });
};
